import React, { useMemo } from 'react'
import { ListItem, ListItemAvatar, Typography } from '@material-ui/core'
import PersonAvatar from '../PersonAvatar'
import { makeStyles } from '@material-ui/styles'
import * as R from 'ramda'
import { FormattedMessage } from 'react-intl'
import { getHumanizeDate } from 'commons/date'

const useStyles = makeStyles((theme) => ({
  avatarStyle: {
    width: '35px',
    height: '35px',
    fontSize: '13px',
  },
  listItemavAtarStyle: {
    minWidth: '35px',
    marginRight: '1rem',
  },
  listItemstyle: {
    cursor: 'pointer',
    padding: '10px 15px',
  },
}))
const Subscriber = ({
  item,
  handleOpenSubscribersDetail,
  lastSeen = false,
}) => {
  const classes = useStyles()
  const openSubscribersDetail = (item) => {
    handleOpenSubscribersDetail(item)
  }
  let humanDate = useMemo(() => {
    return getHumanizeDate(item.lastSeen)
  }, [item.lastSeen])

  return (
    <ListItem
      onClick={() => openSubscribersDetail(item)}
      className={classes.listItemstyle}
    >
      <ListItemAvatar className={classes.listItemavAtarStyle}>
        <PersonAvatar
          placeHolder={item && item.avatarCharacters}
          subId={item.id}
          alt={item.firstName}
          src={item.profilePicture}
          className={classes.avatarStyle}
        />
      </ListItemAvatar>
      <div>
        <Typography className="m-0">{`${item.firstName} ${item.lastName}`}</Typography>
        {lastSeen && !R.isNil(item.lastSeen) ? (
          <Typography className="text-10 text-grey-dark m-0">
            {
              <FormattedMessage
                id="subscriber.lastSeen.label"
                values={{
                  formattedDate: humanDate,
                  dateCount: humanDate.split(',').length,
                }}
              />
            }
          </Typography>
        ) : null}
      </div>
    </ListItem>
  )
}

export default Subscriber
